import React, { useCallback, useEffect, useState } from 'react';
import { Platform, View, type LayoutChangeEvent } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useTopChromeOffset } from '../../navigation/TopChromeOffsetContext';

type Props = {
  children: React.ReactNode;
};

/**
 * Banners globales bajo la status bar en native.
 * Reporta su altura para que el header de tabs no duplique el inset superior.
 */
export function AppTopBanners({ children }: Props) {
  const insets = useSafeAreaInsets();
  const { setGlobalBannerHeight } = useTopChromeOffset();
  const [contentHeight, setContentHeight] = useState(0);

  const onLayout = useCallback((event: LayoutChangeEvent) => {
    setContentHeight(event.nativeEvent.layout.height);
  }, []);

  const hasVisibleBanner = contentHeight > 0;
  const topInset = Platform.OS !== 'web' && hasVisibleBanner ? insets.top : 0;

  useEffect(() => {
    setGlobalBannerHeight(hasVisibleBanner ? contentHeight : 0);
    return () => setGlobalBannerHeight(0);
  }, [contentHeight, hasVisibleBanner, setGlobalBannerHeight]);

  return (
    <View style={topInset > 0 ? { paddingTop: topInset } : undefined} onLayout={onLayout}>
      {children}
    </View>
  );
}
